<template>
  <svg
    width="16"
    height="14"
    viewBox="0 0 16 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.3332 6.66667V3.66667C14.3332 3.29847 14.0347 3 13.6665 3H7.99984L6.33317 1H2.33317C1.96498 1 1.6665 1.29848 1.6665 1.66667V12.3333C1.6665 12.7015 1.96498 13 2.33317 13H7.33317"
      stroke="#0466F9"
      stroke-width="1.58333"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9.6665 11.6666L11.3332 12.9999L14.3332 9.33325"
      stroke="#0466F9"
      stroke-width="1.58333"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {};
</script>

<style></style>
